import { cn } from "@/lib/utils";
import { useCanAutoQualify } from "@/hooks/useCanAutoQualify";
import { useQualificationAnalysis } from "@/hooks/useQualificationAnalysis";
import { useQualificationStatus } from "@/hooks/queries/useQualificationStatus";

export type QualificationFilter = "ANALYZED" | "CALIFICA" | "REVISAR" | null;

const CHIPS: Array<{ value: QualificationFilter; label: string }> = [
  { value: null, label: "Todas" },
  { value: "ANALYZED", label: "Analizadas" },
  { value: "CALIFICA", label: "Califico" },
  { value: "REVISAR", label: "Me falta poco" },
];

/**
 * Filtra el listado por veredicto. Sale en una línea marcada con cruce automático
 * y, en todo plan, cuando la empresa ya tiene obras cruzadas (las del onboarding).
 */
export function QualificationFilterChips({
  lineId,
  value,
  onChange,
}: {
  lineId: number | null;
  value: QualificationFilter;
  onChange: (value: QualificationFilter) => void;
}) {
  const canAutoQualify = useCanAutoQualify();
  const { isLineMarked } = useQualificationAnalysis(lineId);
  const { data: status } = useQualificationStatus();
  // Con un chip puesto se muestran siempre: si no, no habría cómo quitarlo.
  if (!(canAutoQualify && isLineMarked) && !status?.hasAnalyses && value === null) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {CHIPS.map((chip) => (
        <button
          key={chip.label}
          type="button"
          onClick={() => onChange(chip.value)}
          className={cn(
            "cursor-pointer rounded-full border px-3 py-1 text-xs font-semibold transition-colors",
            value === chip.value
              ? "border-primary bg-primary text-primary-foreground"
              : "border-slate-200 text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800",
          )}
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}
